import pickOne from 'pickoneitem';
import domElementsFound from '../utilities/DOM/domElementsFound';
import delayedFocus from '../utilities/accessibility/delayedFocus';

let tabGroup;

const selectors = {
  tab: '[data-account-tab]',
  focusTarget: '[data-focus-target]',
  sectionToggle: '[data-account-toggle]',
};

const getFocusTarget = (section) => {
  const target = section.querySelector(selectors.focusTarget);

  if (!domElementsFound(target)) return section;

  return target;
};

export function toggleAccountTabs(event) {
  const toggleButton = event.target.closest(selectors.sectionToggle);
  const tabSelector = toggleButton.getAttribute('data-account-toggle');

  if (!domElementsFound(toggleButton) || !tabSelector) return;

  // If part of group, hide all but specified tab. Else, close section.
  tabGroup.pick(tabSelector);
  const activeSection = document.querySelector(tabSelector);
  const focusTarget = getFocusTarget(activeSection);
  delayedFocus(focusTarget, 200, { makeFocusable: true });
}

export function activateSectionToggle() {
  const toggle = document.querySelectorAll(selectors.sectionToggle);

  if (!toggle) return;

  tabGroup = pickOne();
  tabGroup.init({
    className: 'hide',
    invert: true,
    group: selectors.tab,
  });

  toggle.forEach((button) => {
    button.addEventListener('click', toggleAccountTabs);
  });
}
